import React, { useState } from "react";
import { useEffect } from "react";
import { Droppable } from "react-beautiful-dnd";
const GroupList = ({
  groups = [],
  deleteGroup,
  deleteGroupValue,
  groupFilter,
  draggedOver
}) => {
  const [openGroupIndex, setOpenGroupIndex] = useState(null);
  const handleClick = (i) => {
    if (i !== openGroupIndex) {
      setOpenGroupIndex(i);
    } else {
      setOpenGroupIndex(null);
    }
  };
useEffect(()=>{
  setOpenGroupIndex(draggedOver)
},[draggedOver])

  return (
    <>
      {groups
        .filter((item) => {
          return item.name.match(new RegExp(groupFilter, "i"));
        })
        .map((group, grpIdx) => (
          <div
            className="created-groups-list d-flex justify-content-between"
            key={grpIdx}
          >
            <Droppable droppableId={group.name}>
              {(provided, snapshot) => (
                <div className={
                  snapshot.isDraggingOver
                    ? "dragOver groups-list-inner"
                    : "groups-list-inner"
                }>
                  <div ref={provided.innerRef}
                    className="h-screen"
                    >

                    <div className="d-flex align-items-center justify-content-between"
                      onClick={() => handleClick(grpIdx)}
                    >
                      <div className="groups-value-box">{group.name}</div>
                      <div className="groups-count-box d-flex align-items-center justify-content-between">
                        <span className="counted-reasons">
                          {group.values && group.values.length} Items
                        </span>
                        <span
                          className="groups-open-icon"
                          onClick={() => handleClick(grpIdx)}
                        ></span>
                      </div>
                    </div>

                    {openGroupIndex === grpIdx && (
                      <div className="groups-reasons-assign">
                        {group.values.map((value, valueIdx) => (
                          <div
                            key={valueIdx}
                            className="groups-reasons-list d-flex align-items-center justify-content-between"
                          >
                            <span className="groups-reasons-value">{value}</span>
                            <span
                              className="groups-delete-action"
                              onClick={() => deleteGroupValue(grpIdx, valueIdx)}
                            ></span>
                          </div>
                        ))}
                      </div>
                    )}
                    {provided.placeholder}
                  </div>
                </div>
              )}
            </Droppable>

            <div
              className="groups-delete-action"
              onClick={() => deleteGroup(grpIdx)}
            ></div>
          </div>
        ))}
    </>
  );
};

export default GroupList;
